import { ref } from 'vue';

interface ConfirmDialogOptions {
  title: string;
  description?: string;
  listDescription?: string[];
  icon?: string;
  iconColor?: string;
  confirmText?: string;
  cancelText?: string;
  confirmTextColor?: string;
  confirm?: () => Promise<void>;
  cancel?: () => Promise<void>;
  hasCancel?: boolean;
  alert?: boolean;
  persistent?: boolean;
}

// Shared state
const state = {
  isOpen: ref(false),
  pending: ref(false),
  options: ref<ConfirmDialogOptions | null>({
    title: 'Quit registration',
    description: 'Are you sure you want to quit?',
    listDescription: [],
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    confirmTextColor: 'primary',
    icon: 'question-mark.svg',
    iconColor: 'primary',
    confirm: async () => {},
    hasCancel: true,
    alert: false,
    persistent: true,
  }),
};

export function useConfirmDialog() {
  const showConfirmDialog = (dialogOptions: ConfirmDialogOptions) => {
    state.options.value = {
      confirmText: dialogOptions.confirmText || 'Confirm',
      cancelText: dialogOptions.cancelText || 'Cancel',
      confirmTextColor: dialogOptions.confirmTextColor || 'primary',
      icon: dialogOptions.icon,
      iconColor: dialogOptions.iconColor || 'primary',
      hasCancel: Boolean(dialogOptions.hasCancel),
      persistent: dialogOptions.persistent || true,
      ...dialogOptions,
    };
    state.isOpen.value = true;
  };

  const handleConfirm = async () => {
    state.pending.value = true;
    await state.options.value?.confirm?.();
    state.isOpen.value = false;
    state.options.value = null;
    state.pending.value = false;
  };

  const handleCancel = () => {
    state.options.value?.cancel?.();
    state.isOpen.value = false;
    state.options.value = null;
  };

  const hideDialog = () => {
    state.isOpen.value = false;
    state.options.value = null;
    state.pending.value = false;
  };

  return {
    isOpen: state.isOpen,
    options: state.options,
    showConfirmDialog,
    handleConfirm,
    handleCancel,
    pending: state.pending,
    hideDialog,
  };
}
